<script>
import InfoIcon from "../svg/InfoIcon.vue";
import Modal from "../Modal.vue";
import AppointmentStore from "../../mixins/appointment-store";

export default {
    name: "ServiceRow",
    components: {InfoIcon},

    mixins: [AppointmentStore],

    props: {
        service: Object
    },

    computed: {
        active() {
            return this.appointmentStore.selectedServiceIds.includes(this.service.id)
        },
    },

    methods: {
        handleShowModal() {
            this.$modal.show(Modal, {
                content: this.service.description,
            }, {
                width: '90%',
                maxWidth: 600,
                adaptive: true,
                height: 'auto',
                scrollable: true
            })
        }
    }
}
</script>

<template>
    <div class="vue-service-row">
        <input :id="service.name" :name="service.name" @click="appointmentStore.toggleServiceId(service.id)" type="checkbox" :checked="active" readonly class="service-checkbox">

        <label :for="service.name">
            {{ service.name }}</label>

        <button type="button" @click.stop="handleShowModal">
            <InfoIcon />
            <span class="visually-hidden">Tooltip</span>
        </button>
    </div>
</template>